import PropTypes from "prop-types";
import { createContext, useContext, useState } from "react";

export const ItineraryThemeContext = createContext(null);

const themes = {
  1: {
    text: {
      primary: "text-itinerary-green-100",
      secondary: "text-sand-200",
      tertiary: "text-itinerary-green-500",
    },
    background: {
      primary: "bg-itinerary-green-100",
      secondary: "bg-sand-200",
      tertiary: "bg-itinerary-green-500",
    },
  },
  2: {
    text: {
      primary: "text-itinerary-green-100",
      secondary: "text-sand-200",
      tertiary: "text-itinerary-red-500",
    },
    background: {
      primary: "bg-itinerary-green-100",
      secondary: "bg-sand-200",
      tertiary: "bg-itinerary-red-500",
    },
  },
};

export function ItineraryThemeContextProvider({ children }) {
  const [
    theme,
    // setTheme
  ] = useState(1);

  return (
    <ItineraryThemeContext.Provider value={themes[theme]}>
      {children}
    </ItineraryThemeContext.Provider>
  );
}

export function useItineraryTheme() {
  const ctx = useContext(ItineraryThemeContext);

  if (!ctx) {
    throw new Error(
      "useItineraryTheme must be used within an ItineraryThemeContextProvider"
    );
  }

  return ctx;
}

ItineraryThemeContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
